<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <div class="text-center">
        <img src="../assets/img/icon/P.svg" />
        <br />
        <img src="../assets/img/icon/Pickiddo.svg" class="mt-2" />
        <br />
        <img src="../assets/img/icon/Bringing.svg" class="mt-2" />
        <br />
        <label class="mt-5 custom-label-note">CONTINUE WITH </label>
        <br />
        <CButton color="info" class="custom-btn-login-active" disabled>
          <CRow>
            <div class="icon-custom-width">
              <img src="../assets/img/icon/iconGoogle.svg" />
            </div>
            <div class="custom-btn-google text-center float-none">Google</div>
            <div class="icon-custom-width"></div> </CRow
        ></CButton>
        <br />
        <CButton color="info" class="custom-btn-login-active mt-3" disabled>
          <CRow>
            <div class="icon-custom-width">
              <img src="../assets/img/icon/iconApple.svg" />
            </div>
            <div class="custom-btn-google text-center float-none">Apple</div>
            <div class="icon-custom-width"></div> </CRow
        ></CButton>
        <br />
        <img src="../assets/img/icon/lineOr.svg" class="mt-3" />
        <br />
        <CButton color="info" class="custom-btn-login-active mt-3" @click="GoToLogin()">
          Continue with email</CButton
        >
        <br />
        <a href="" class="custom-href mt-4">Continue as Guest</a>
        <br />
      </div>
    </CContainer>
    <div class="header-top">Login</div>
    <div class="header-left" @click="GoBack()"><img src="../assets/img/icon/VectorLeft.svg"></div>
  </div>
</template>
<script>
export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
    };
  },
  async mounted() {},
  methods: {
    GoBack() {
     this.$router.back();
    },
     GoGoogle() {
    this.$router.push("ContactInformation");
    },
    GoToLogin()
    {
     this.$router.push("LoginInformation");
    },
  },
};
</script>



<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}

</style>